(function () {
  function onSubmit(evt) {
    var form = evt.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var button = form.querySelector('.product-form__submit');
    if (!button) return;
    button.classList.remove('soap-bounce');
    // Force un reflow pour pouvoir rejouer l'animation si deux ajouts se suivent rapidement.
    void button.offsetWidth;
    button.classList.add('soap-bounce');
  }

  document.addEventListener('submit', onSubmit);
})();
